import React from 'react';

export const PageNotFound = () => {
    return (
        <div>
            <h2>Page Not Found</h2>
        </div>
    );
};